import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PATHS } from './common/constants';
import { selectAuthenticatedUser } from './store/selectors/auth';
import { useInboxUnreadCountPolling } from 'src/SharedCustomHooks/UseInboxUnreadCount/useInboxUnreadCountPolling';
import ServiceRequest from './pages/ServiceRequest';
import Settings from './pages/Settings/Settings';
import ReactGA from 'react-ga4';
import { browserHistory } from './history';
import AdminRoutes from './Routes/AdminRoutes';
import StrataManagerRoutes from './Routes/StrataManagerRoutes';
import PublicRoutes from './Routes/PublicRoutes';
import InboxContainer from './pages/Inbox/InboxContainer';
import VideoChat from './pages/VideoChat';
import HomeownerRoutes from 'src/Routes/HomeownerRoutes';
import Request from './pages/Request/Request';
import CalendarComponent from 'src/pages/Calendar/CalendarComponent';
import ServiceRequests from 'src/pages/ServiceRequests/ServiceRequests';

browserHistory.listen((location) => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page.
  ReactGA.pageview(location.pathname); // Record a pageview for the given page.
});

function AppShell() {
  const user = useSelector(selectAuthenticatedUser);

  useInboxUnreadCountPolling(user?.id);

  /* Confirm-email-change link may be opened while logged in. Route through
   * PublicRoutes so confirm and sign-in share the app's single Router instance,
   * enabling client-side navigation from the confirmation screen to sign-in. */
  if (window.location.pathname === PATHS.AUTH_CONFIRM_EMAIL_CHANGE) {
    return <PublicRoutes />;
  }

  if (!user?.id) {
    return <PublicRoutes />;
  }

  const roleName = user.roles[0].role.name;

  if (roleName === 'Service Manager' || roleName === 'Service Provider') {
    return (
      <Switch>
        <Route path={PATHS.SERVICE_REQUESTS_VIEW} component={ServiceRequest} />
        <Route path={PATHS.SERVICE_REQUESTS_LIST} component={ServiceRequests} />
        <Route path={PATHS.CALENDAR} component={CalendarComponent} />
        <Route path={PATHS.SETTINGS} component={Settings} />
        <Route path={PATHS.VIDEO_CHAT} component={VideoChat} />
        <Route path={PATHS.INBOX} component={InboxContainer} />
        <Route path={PATHS.REQUEST} component={Request} />
        <Route path="/">
          <Redirect to={PATHS.SERVICE_REQUESTS_LIST} />
        </Route>
      </Switch>
    );
  }

  if (
    roleName === 'Home Owner' ||
    roleName === 'Realtor' ||
    roleName === 'Occupant'
  ) {
    return <HomeownerRoutes />;
  }

  if (roleName === 'Strata Manager') {
    return <StrataManagerRoutes />;
  }

  return <AdminRoutes />;
}

export default AppShell;
